<app-update-banner />
<div class="top">
  <app-top variant="portal"></app-top>
</div>
<div class="middle">
  <div class="portal-content">
    <router-outlet />
  </div>
</div>
